import { Bell, Home, Mail, Shield, Target, Users } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import { apiGetNotifications } from "../../../api/notifications";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";
import { ReactComponent as Logout } from "../../../assets/images/logoutIcon.svg";
import { logout } from "../../../redux/actions/login";
import "./Navbar.scss";

const navItems = [
  { icon: Home,    label: 'Dashboard',    path: '/',                  exact: true },
  { icon: Target,    label: 'Investimentos', path: '/investimentos', match: ['investimentos'] },
  { icon: Users,   label: 'Investidores', path: '/investidores',      match: ['investidores'] },
  { icon: Shield,  label: 'Acessos',      path: '/acessos/gestores',  match: ['acessos'] },
  { icon: Mail,    label: 'Contato',      path: '/contato',           match: ['contato'] },
];

const Navbar = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const notificationsRef = useRef(null);

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.path;
    return item.match?.some(seg => location.pathname.includes(seg));
  };

  const formatRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now - date;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMinutes < 60) return `${diffInMinutes} minuto${diffInMinutes !== 1 ? 's' : ''} atrás`;
    if (diffInHours < 24) return `${diffInHours} hora${diffInHours !== 1 ? 's' : ''} atrás`;
    return `${diffInDays} dia${diffInDays !== 1 ? 's' : ''} atrás`;
  };

  useEffect(() => {
    setLoading(true);
    apiGetNotifications().then(data => {
      if (data?.items) setNotifications(data.items);
    }).catch(err => {
      console.error(err);
    }).finally(() => {
      setLoading(false);
    });
  }, [history]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    if (showNotifications) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showNotifications]);

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <nav className="Navbar">
      <div className="Navbar__container">
      <button className="Navbar__logo" onClick={() => history.push("/")}>
        <Logo />
      </button>

      <div className="Navbar__right">
        <div className="Navbar__links">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item);
            return (
              <button
                key={item.path}
                className={`Navbar__link${active ? ' Navbar__link--active' : ''}`}
                onClick={() => history.push(item.path)}
              >
                <Icon className="Navbar__link-icon" />
                <span>{item.label}</span>
                {active && <div className="Navbar__link-underline" />}
              </button>
            );
          })}
        </div>

        <div className="notifications-container" ref={notificationsRef}>
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="notifications-button"
          >
            <Bell className="bell-icon" />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </button>

          {showNotifications && (
            <div className="notifications-dropdown">
              <div className="notifications-header">
                <h3>Notificações</h3>
              </div>
              <div className="notifications-list">
                {loading ? (
                  <div className="notification-item">
                    <p className="notification-message">Carregando notificações...</p>
                  </div>
                ) : notifications.length === 0 ? (
                  <div className="notification-item">
                    <p className="notification-message">Nenhuma notificação encontrada</p>
                  </div>
                ) : (
                  notifications.slice(0, 3).map((notification) => (
                    <div
                      key={notification.id}
                      className={`notification-item${!notification.read ? ' unread' : ''}`}
                    >
                      <div className="notification-content">
                        <p className="notification-message">
                          <strong>{notification.title}</strong>
                          {notification.description && <><br />{notification.description}</>}
                        </p>
                        {!notification.read && <div className="unread-indicator" />}
                      </div>
                      <p className="notification-time">{formatRelativeTime(notification.created_at)}</p>
                    </div>
                  ))
                )}
              </div>
              <div className="notifications-footer">
                <button
                  onClick={() => { setShowNotifications(false); history.push('/notificacoes'); }}
                  className="view-all-button"
                >
                  Ver todas as notificações
                </button>
              </div>
            </div>
          )}
        </div>

        <button className="Navbar__logout" onClick={() => dispatch(logout()).then(() => history.push("/login"))}>
          Sair
          <Logout />
        </button>
      </div>
      </div>
    </nav>

  );
};

export default Navbar;
